import { render, staticRenderFns } from "./TabPlastic.vue?vue&type=template&id=81252ff8&scoped=true&"
import script from "./TabPlastic.vue?vue&type=script&lang=js&"
export * from "./TabPlastic.vue?vue&type=script&lang=js&"
import style0 from "./TabPlastic.vue?vue&type=style&index=0&id=81252ff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81252ff8",
  null
  
)

export default component.exports